// extracted by mini-css-extract-plugin
export default {"sectionHeader":"Header_sectionHeader__W6zfG","titleContainer":"Header_titleContainer__2133n","mainTitle":"Header_mainTitle__B9pgg"};